import { render, staticRenderFns } from "./VendorDashboard.vue?vue&type=template&id=28cca7f6&scoped=true"
import script from "./VendorDashboard.vue?vue&type=script&lang=js"
export * from "./VendorDashboard.vue?vue&type=script&lang=js"
import style0 from "./VendorDashboard.vue?vue&type=style&index=0&id=28cca7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cca7f6",
  null
  
)

export default component.exports